<template>
  <el-dialog
    :visible="visible"
    class="onshelf-result-dialog"
    title="提示"
    width="700px"
    :before-close="close"
  >
    <span class="tips">成功上架:{{resultData.successNum}}个店铺, 失败{{(resultData.failedList && resultData.failedList.length) || 0}}个商品:</span>
    <div class="failed-box">
      <el-table
        :data="resultData.failedList"
        style="width: 100%"
      >
        <el-table-column
          prop="outerId"
          label="商品款式编码"
          width="150"
        />
        <el-table-column
          label="店铺名称"
        >
        <template slot-scope="{row}">
          <span v-if="row.shopName">{{row.shopName}}</span>
          <span v-else>{{formatShopNameById(row.shopId)}}</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="errorMsg"
          label="错误信息"
        />
      </el-table>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="close">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'onShelfResult',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    close: Function,
    resultData: {
      type: Object,
      default: () => {
        return {
          successNum: 0,
          failedList: []
        }
      }
    }
  },
  methods: {
    // 格式化来源店铺名称通过店铺id
    formatShopNameById(shopId) {
      return (this.$store.getters.shops_getById(shopId) || {}).title;
    },
  }
}
</script>

<style lang="scss" scoped>
.onshelf-result-dialog {
  .tips {
    font-size: 12px;
  }
  .failed-box {
    margin-top: 20px;
  }
}
</style>